module.exports = __webpack_public_path__ + "img/sb13.d8c8cab6.png";